import { render } from "./BottomBarHome.vue?vue&type=template&id=ca5fa1b0"
import script from "./BottomBarHome.vue?vue&type=script&lang=js"
export * from "./BottomBarHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__